import React from 'react';

import { MachinesSummaryContainer } from '../../containers/machinesSummary';

export const MachinesSummary: React.FC = () => <MachinesSummaryContainer />;